module.exports = __webpack_public_path__ + "assets/eye.a18f1b79.svg";